var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "QA"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "white",
    stroke: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_808_1749",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Mask_2",
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_808_1749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9994 0H4.28516L5.35658 1L4.28516 2L5.35658 3L4.28516 4L5.35658 5L4.28516 6L5.35658 7L4.28516 8L5.35658 9L4.28516 10L5.35658 11L4.28516 12L5.35658 13L4.28516 14L5.35658 15H14.9994V0Z",
    fill: "#A6264C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQa);
export default __webpack_public_path__ + "static/media/QA.66d72096c9ee0cb8002602cf79efdb51.svg";
export { ForwardRef as ReactComponent };